import _ from 'lodash';
import { Redirect } from 'react-router-dom';
import React, { useState, useContext, useEffect } from 'react';
import { Form, Icon, Message } from 'semantic-ui-react';

import { login } from '../../fetcher';
import { UserContext } from '../../context';

const { REACT_APP_SEKOLAH_KODE } = process.env;
const LoginSection = ({ setForm }) => {
	const [isLoading, toggleLoading] = useState(false);
	const [formValue, setFormValue] = useState({ sekolah_kode: REACT_APP_SEKOLAH_KODE, username: '', password: '' });
	const [formStatus, setFormStatus] = useState({});

	const session = useContext(UserContext);
	const nama_sekolah = _.get(session, 'sekolah.nama');

	useEffect(() => {
		document.title = nama_sekolah;
	});

	const handleSubmit = async () => {
		toggleLoading(true);
		const response = await login(formValue);
		if (response.status_code === 200) {
			await session.checkUser();
			return <Redirect to="/" />;
		} else {
			const formStatus = { status: 'error', props: {} }
			switch (response.message) {
				case "Username and Password combination is invalid": {
					formStatus.props = { error: true, size: 'tiny', header: 'Login Gagal', content: 'Kombinasi nisn dan password yang Anda masukan tidak sesuai' };
					break;
				}
				default: 
			}
			toggleLoading(false);
			return setFormStatus(formStatus);
		}
	}
	const handleChange = (e, data) => {
		const { name, value } = data;
		setFormStatus({});
		return setFormValue(_.assign({}, formValue, { [name]: value }));
	}

	const { username, password } = formValue;
	const is_error = _.isEqual(formStatus.status, 'error');
	return (<>
		<Form className="theme" error={is_error} >
			<Form.Field required>
				<label>NISN</label>
				<Form.Input disabled={isLoading} name="username" value={username || ""} onChange={handleChange} placeholder='Masukkan NISN unik Anda' />
			</Form.Field>
			<Form.Field required>
				<label>Password</label>
				<Form.Input disabled={isLoading} name="password" value={password || ""} onChange={handleChange} type="password" placeholder='Masukkan password / kata sandi akun Anda' />
			</Form.Field>
			{!_.isEmpty(formStatus) && <Message {...formStatus.props} />}
			<Form.Button color="theme" type="submit" floated="right" disabled={isLoading} loading={isLoading} onClick={handleSubmit}>Masuk <Icon name="arrow right" /></Form.Button>
		</Form>
		<p style={{marginTop: "1em"}}>Hubungi Wali Kelas untuk mengetahui password kamu.</p>
	</>
	);
};

export default LoginSection;